import React from "react"
import PropTypes from "prop-types"
import Form from "./form"
import FlashAlert from '../flash-alert'

class RecurringReservations extends React.Component {
  constructor(props) {
    super(props)
    this.state = { alert: null }
  }
  componentWillMount() {
    const { reservationId, initRecurring } = this.props
    initRecurring(reservationId)
  }

  onError = (data) => {
    this.setState({ alert: data })    
  }

  submitForm = (data) => {
    const { reservationId, onSubmit, onChanged } = this.props
    onSubmit({ id: reservationId, data: data, onSubmitted: onChanged, onError: this.onError})
  }

  render() {
    const {items, errors, disabled, currentValues, reservationId, defaultDate, onEdit, onRevert} = this.props
    const alert = this.state.alert

    return (
      <div>
        { alert && <FlashAlert text={alert.text} type={alert.type} html={alert.html} constant onHide={() => this.setState({ alert: null })} />}
        <div className="modal-body edit-recurrings">
          <Form
            initialValues={{items}}
            errors={errors}
            reservationId={reservationId}
            defaultDate={defaultDate}
            submitDisabled={disabled}
            currentValues={currentValues}
            onEdit={onEdit}
            onRevert={onRevert}
            onSubmit={this.submitForm}
          />
        </div>
      </div>
    )
  }
}

RecurringReservations.propTypes = {
  items: PropTypes.array,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  currentValues: PropTypes.object,
  reservationId: PropTypes.number,
  defaultDate: PropTypes.string,
  initRecurring: PropTypes.func,
  onEdit: PropTypes.func,
  onChanged: PropTypes.func,
  onRevert: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default RecurringReservations
